

//TODO this constants for prod server
export const SERVER_API = process.env.NODE_ENV === "development" ? "http://localhost:4220/api" : "https://eurotechseating.com/api";

export const SERVER_API_ORDERS = process.env.NODE_ENV === "development" ? "http://localhost:4220/api" : "https://orders-service-production-8167.up.railway.app/api";

// NODE_ENV === "development" ? "http://localhost:4220/api": "https://orders-service-production-8167.up.railway.app/api";

//TODO this constants for test server
// export const SERVER_API = process.env.NODE_ENV === "development" ? "http://localhost:4220/api" : "https://3.15.157.9:80/api";